import { render, staticRenderFns } from "./ComboboxStatusRelacionamento.vue?vue&type=template&id=50961d00"
import script from "./ComboboxStatusRelacionamento.vue?vue&type=script&lang=js"
export * from "./ComboboxStatusRelacionamento.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports